import React, { useState, useEffect } from "react";
import Header from "../../../../Components/Header.js";
import { motion } from "framer-motion";
import BlackButton from "../../../../Components/BlackButton.js";
import { ArrowRight } from "lucide-react";
import GradientGlowDivider from "../../../../Components/GradientGlowDivider.js";
import useGlobalState from "../../../../global.js";
import { Link } from "react-scroll";

const HomeInitialSection = () => {
  const [, setCursorVariant] = useGlobalState("cursorVariant");
  const [isHovering, setIsHovering] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const mouseMove = (e) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY,
      });
    };
    window.addEventListener("mousemove", mouseMove);

    return () => window.removeEventListener("mousemove", mouseMove);
  }, []);

  const variants = {
    default: {
      x: mousePosition.x - 2,
      y: mousePosition.y - 2,
      opacity: 0,
      width: 0,
      height: 0,
      boxShadow: "0 0 0 0 rgba(150, 150, 150, 0)",
      transition: {
        type: "spring",
        mass: 1,
        stiffness: 100,
        damping: 15,
      },
    },
    visible: {
      x: mousePosition.x - 2,
      y: mousePosition.y - 2,
      opacity: 0,
      width: 0,
      height: 0,
      backgroundColor: "transparent",
      boxShadow: "0 0 30px 15px rgba(150, 150, 150, 0.15)",
      transition: {
        type: "spring",
        mass: 1,
        stiffness: 100,
        damping: 15,
      },
    },
    hover: {
      x: mousePosition.x - 2,
      y: mousePosition.y - 2,
      opacity: 0.7,
      width: 0,
      height: 0,
      backgroundColor: "transparent",
      boxShadow: "0 0 200px 120px rgba(150, 150, 150, 0.5)",
      transition: {
        type: "spring",
        mass: 1,
        stiffness: 100,
        damping: 15,
      },
    },
  };

  return (
    <section className="relative">
      <motion.div
        className="hidden md:block fixed rounded-full pointer-events-none z-50 w-[40px] h-[40px]"
        variants={variants}
        animate={isHovering ? "hover" : "visible"}
        initial="default"
      />

      <div className="flex flex-col md:flex-row p-1 md:p-4 min-h-[86vh] md:min-h-screen">
        <div
          className="flex-1 flex relative bg-black rounded-2xl border-[0.1px] border-white shadow-lg shadow-gray-700/30"
          onMouseEnter={() => {
            setIsHovering(true);
            setCursorVariant("visible");
          }}
          onMouseLeave={() => {
            setIsHovering(false);
            setCursorVariant("default");
          }}
        >
          <div className="text-white flex-1 flex flex-col">
            <video
              className="absolute inset-0 w-full h-full object-cover rounded-2xl filter grayscale opacity-40"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src="/videos/datapixl_intro.mp4" type="video/mp4" />
              <source src="/videos/datapixl_intro.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>

            <div className="hidden md:block z-10">
              <Header className="md:px-16 md:mt-0" />
            </div>

            <div className="w-[90%] mx-auto hidden md:block">
              <GradientGlowDivider />
            </div>

            <main className="flex-1 flex flex-col items-center pt-[36%] md:pt-[6%] mx-[6%] md:mx-[20%] z-10">
              <h1 className="text-4xl md:text-8xl font-extrabold text-center text-white leading-[140%] tracking-[0] mb-6">
                AI Strategy Meets Execution
              </h1>

              <p className="text-center text-lg md:text-xl font-medium leading-[140%] tracking-[0] text-white max-w-2xl mb-12">
                Unlocking business potential with AI solutions that drive
                strategy, execution, and transformative impact with speed and
                precision.
              </p>
              <Link to="learn-more" smooth="true" duration={100}>
                <BlackButton
                  text="Learn More"
                  icon={<ArrowRight />}
                  onClick={() => {}}
                />
              </Link>
            </main>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeInitialSection;
